import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { loadModules } from 'esri-loader';
import {ConfigApp, Services} from '../../../config';
import {callService, redirectPage, resetSessionVariable} from '../../../data.service';

import {AppComponent} from "../../../app.component";
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-page-login',
  templateUrl: './page-login.component.html'
})
export class PageLoginComponent implements OnInit {

  public config: any;
  public configUser: any;
  public messageError: any;

  ngOnInit() {
    this.configUser = environment.userInfo;
    $("body").addClass("authentication-bg");
    $(".content-page").css("margin-left","0");
    $(".content-page").css("padding","0 0");
    this.config = ConfigApp;
    resetSessionVariable();
    AppComponent.hideLoading();
    if(!ConfigApp.debug && ConfigApp.appId){
      this.onLoginOauth();
    }

  }

  displayPassword(e){
    if ($(e.currentTarget).attr('data-password') == "false") {
      $(e.currentTarget).siblings("input").attr("type", "text");
      $(e.currentTarget).attr('data-password', 'true');
      $(e.currentTarget).addClass("show-password");
    } else {
      $(e.currentTarget).siblings("input").attr("type", "password");
      $(e.currentTarget).attr('data-password', 'false');
      $(e.currentTarget).removeClass("show-password");
    }
  }

  onLoginOauth() {
    let that = this;
    return new Promise<any>(async () => {
      const [Portal, OAuthInfo, esriId] = await loadModules(["esri/portal/Portal", "esri/identity/OAuthInfo", "esri/identity/IdentityManager"], {css: true,});

      const info = new OAuthInfo({
        appId: ConfigApp.appId,
        portalUrl: ConfigApp.portalUrl,
        popup: false // the default
      });

      esriId.registerOAuthInfos([info]);
      esriId.checkSignInStatus(ConfigApp.portalUrl + "/sharing").then(function(){
        const portal = new Portal();
        portal.load().then((r) => {
          function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }

          try {
            let control = false;
            if(getCookie("esri_auth")){
              sessionStorage.setItem("tokenR", getCookie("esri_auth"));
              sessionStorage.setItem("token", JSON.parse(getCookie("esri_auth")).token);
              control = true;
            }

            if(sessionStorage.getItem("esriJSAPIOAuth")){
              sessionStorage.setItem("tokenR", JSON.stringify(JSON.parse(sessionStorage.getItem("esriJSAPIOAuth"))["/"][ConfigApp.portalUrl]));
              sessionStorage.setItem("token", JSON.parse(sessionStorage.getItem("esriJSAPIOAuth"))["/"][ConfigApp.portalUrl].token);
              control = true;
            }

            if(!control) return false;
            Services.self.params.token = sessionStorage.getItem("token");
            callService(Services.self).done(function( resultsSelf ) {
              $("#feedbackLoading").hide();

              if(!that.controlGroup(resultsSelf)){
                return;
              }
              if(!(resultsSelf && resultsSelf.hasOwnProperty("access") )){
                $("#signin").show();
                $("#feedbackAlert").show();
                $("#feedbackLoading").hide();
                return;
              }

              sessionStorage.setItem("user", JSON.stringify(resultsSelf));
              return redirectPage("dashboard");

            });
            return true;
          } catch (e) {
            console.error("Error Login");
            return false;
          }

        });
      });

      esriId.getCredential(ConfigApp.portalUrl + "/sharing").then(function(resp){
      });
    });

  }

  onLogin(e){
    let that = this;
    e.preventDefault();
    e.stopPropagation();

    $("#feedbackAlert").hide();
    $("#signin").hide();
    $("#feedbackLoading").show();

    Services.generateToken.params.username = $("#username").val();
    Services.generateToken.params.password = $("#password").val();

    callService(Services.generateToken).done(function( results ) {
      if (typeof results === 'string' || results instanceof String){
        // @ts-ignore
        results = JSON.parse(results);
      }
      if(results && results.token){
        let token = results.token;

        sessionStorage.setItem("tokenR", JSON.stringify(results));
        sessionStorage.setItem("token", token);

        Services.self.params.token = token;

        callService(Services.self).done(function( resultsSelf ) {
          $("#feedbackLoading").hide();

          if(!that.controlGroup(resultsSelf)){
            return;
          }
          if(!(resultsSelf && resultsSelf.hasOwnProperty("access") )){
            $("#signin").show();
            $("#feedbackAlert").show();
            $("#feedbackLoading").hide();
            return;
          }

          sessionStorage.setItem("user", JSON.stringify(resultsSelf));
          return redirectPage("dashboard");

        });
      }else{
        $("#signin").show();
        $("#feedbackAlert").show();
        $("#feedbackLoading").hide();
      }
    }).fail(function(){
      $("#signin").show();
      $("#feedbackAlert").show();
      $("#feedbackLoading").hide();
    });
  }


  controlGroup(resultsSelf){
    let that = this;

    let foundGroup = resultsSelf.groups.filter(function(item){
      return item.title.indexOf(that.configUser.groupPermissionPart) !== -1;
    });

    if(!(foundGroup && foundGroup.length)){
      $("#signin").show();
      $("#errorPermission").show();
      $("#feedbackLoading").hide();

      this.messageError = "Nessun gruppo associato valido all'utente";
      return false;
    }

    let foundGroup2 = resultsSelf.groups.filter(function(item){
      return item.title !== that.configUser.uploadGroup;
    });
    if(!(foundGroup2 && foundGroup2.length)){
      $("#signin").show();
      $("#errorPermission").show();
      $("#feedbackLoading").hide();

      this.messageError = "L'utente non fa parte del gruppo "+ this.configUser.uploadGroup;
      return false;
    }

    return true;
  }



}


